var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "column is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd",
    },
    [
      _c("ValidationProvider", {
        attrs: { rules: "required", name: _vm.label },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ errors, valid }) {
              return [
                _c(
                  "b-field",
                  {
                    attrs: {
                      label: _vm.label,
                      message: errors,
                      type: { "is-danger": errors[0], "is-success": valid },
                    },
                  },
                  [
                    _c(
                      "b-tooltip",
                      { attrs: { label: _vm.tooltip, position: "is-bottom" } },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.auxValue,
                                expression: "auxValue",
                              },
                            ],
                            staticClass: "creditu-select",
                            attrs: { id: _vm.id, expanded: "" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.auxValue = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.items, function (item) {
                            return _c(
                              "option",
                              {
                                key: item.value,
                                domProps: { value: item.value },
                              },
                              [_vm._v(" " + _vm._s(item.text) + " ")]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }